
import { useState, useEffect } from 'react';

export default function BackToTop() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-gradient-to-br from-[#E84A1F] to-[#C83A15] rounded-full shadow-lg shadow-[#E84A1F]/30 cursor-pointer transition-all duration-500 group hover:shadow-[0_0_30px_rgba(232,74,31,0.5)] hover:scale-110 active:scale-95 ${
        isVisible 
          ? 'opacity-100 translate-y-0' 
          : 'opacity-0 translate-y-10 pointer-events-none'
      }`}
      aria-label="返回顶部"
    >
      {/* 背景光效 */}
      <div className="absolute inset-0 rounded-full bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>
      
      {/* 脉冲动画 */}
      <div className="absolute inset-0 rounded-full bg-[#E84A1F]/50 animate-ping opacity-0 group-hover:opacity-30"></div>
      
      {/* 箭头图标 */}
      <i className="ri-arrow-up-line text-white text-lg sm:text-xl relative z-10 group-hover:-translate-y-0.5 transition-transform duration-300"></i>
    </button>
  );
}
